import licenseModule from '../../license.module';

export default licenseModule.component('licenseNewServerDetails', {
    template: require('./licenseNewServerDetails.component.html'),
    controller: licenseNewServerDetailsComponent,
    bindings: {
        licenseServerName: '<',
        licenseServerCountry: '<',
        licenseServerDescription: '<',
        serverProfiles: '<',
        callback: '&'
    }
});

function licenseNewServerDetailsComponent() {
    var vm = this;
    vm.$onInit = function() {
        vm.table = {
            options: {
                paging: {
                    itemsPerPage: 5
                },
                sortable: false,
                startRows: 1,
                columns: [
                    {
                        name: 'no',
                        label: ''
                    },
                    {
                        name: 'attribute',
                        label: 'Attribute'
                    },
                    {
                        name: 'value',
                        label: 'Value'
                    }
                ]
            }
        };
    };
}



// WEBPACK FOOTER //
// ./modules/license/features/license-new-server-details/licenseNewServerDetails.component.js